<div class="ancillary-cost-container" *transloco="let t; prefix: 'maintenanceCosting'">
  <div class="filter-container d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h3 class="section-title">{{ t('ancillary.title') }}</h3>
    </div>

    <div class="filter-controls d-flex align-items-center gap-2">
      <div class="search-wrapper">
        <app-search
          [placeholder]="t('ancillary.searchPlaceholder')"
          [disabled]="isLoading"
          (searchTermUpdated)="onSearchTermUpdate($event)"
          [searchTerm]="searchTerm"
          [customWidth]="'385px'">
        </app-search>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div class="table-inner">
      <div class="table-frame" [style.--visible-rows]="pageSize">
        <table class="costs-table">
          <thead>
            <tr>
              <th class="asset">{{ t('ancillary.table.asset') }}</th>
              <th class="date">{{ t('ancillary.table.date') }}</th>
              <th class="category">{{ t('ancillary.table.category') }}</th>
              <th class="description">{{ t('ancillary.table.description') }}</th>
              <th class="cost">{{ t('ancillary.table.cost') }}</th>
              <th class="odometer">{{ t('ancillary.table.odometer') }}</th>
              <th class="invoice">{{ t('ancillary.table.invoiceReference') }}</th>
              <th class="notes">{{ t('ancillary.table.notes') }}</th>
            </tr>
          </thead>
          <tbody>
            @if(isLoading) {
              <tr>
                <td colspan="8" class="loading-cell">
                  <div class="spinner-wrapper">
                    <div class="spinner-border"></div>
                  </div>
                </td>
              </tr>
            } @else {
              @if(!costs.length) {
                <tr>
                  <td colspan="8" class="empty-cell">
                    <app-empty-state></app-empty-state>
                  </td>
                </tr>
              }
              @for(cost of costs; track cost.id) {
                <tr class="cost-row">
                  <td class="asset">{{ cost.assetName }}</td>
                  <td class="date">{{ cost.date | date: 'dd/MM/yyyy' }}</td>
                  <td class="category">{{ cost.category }}</td>
                  <td class="description">{{ cost.description || '-' }}</td>
                  <td class="cost">{{ formatCurrency(cost.cost) }}</td>
                  <td class="odometer">{{ formatOdometer(cost.odometer) }}</td>
                  <td class="invoice">
                    @if(cost.invoiceUrl) {
                      <button type="button" class="invoice-link" [title]="t('ancillary.viewInvoice')" (click)="onViewInvoice(cost)">
                        {{ cost.invoiceNumber || cost.invoiceFileName }}
                      </button>
                    } @else {
                      {{ cost.invoiceNumber || '-' }}
                    }
                  </td>
                  <td class="notes">{{ cost.notes || '-' }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-footer d-flex justify-content-between align-items-center">
      @if(!isFullView && totalCount > previewPageSize) {
        <button class="btn view-all-btn" [disabled]="isLoading" (click)="onViewAll()">
          {{ t('shared.viewAll') }}
        </button>
      } @else if(isFullView) {
        <p class="pagination-text">
          {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
        </p>
      } @else {
        <div></div>
      }

      @if(isFullView) {
        <app-pagination
          [totalPages]="totalPages"
          [currentPage]="page"
          (pageChange)="goToPage($event)">
        </app-pagination>
      }

      <div></div>
    </div>
  </div>
</div>